const pad = (value, length = 2) => String(value).padStart(length, '0');

export const getLocalDateInputValue = (date = new Date()) => {
  const current = date instanceof Date ? date : new Date(date);

  return [
    current.getFullYear(),
    pad(current.getMonth() + 1),
    pad(current.getDate())
  ].join('-');
};

export const toDateInputValue = (value) => {
  if (!value) {
    return getLocalDateInputValue();
  }

  if (typeof value === 'string') {
    return value.slice(0, 10);
  }

  return getLocalDateInputValue(value);
};

const parseRecordDate = (value) => {
  if (!value) {
    return null;
  }

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  if (typeof value !== 'string') {
    return null;
  }

  const match = value.match(
    /^(\d{4})-(\d{2})-(\d{2})(?:[T\s](\d{2}):(\d{2})(?::(\d{2})(?:\.(\d{1,3}))?)?(?:Z)?)?$/
  );

  if (!match) {
    const parsed = new Date(value);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
  }

  const [, year, month, day, hour = '00', minute = '00', second = '00', millisecond = '0'] = match;

  return new Date(
    Number(year),
    Number(month) - 1,
    Number(day),
    Number(hour),
    Number(minute),
    Number(second),
    Number(millisecond.padEnd(3, '0'))
  );
};

export const formatRecordDate = (value, locale = 'tr-TR') => {
  const parsed = parseRecordDate(value);

  if (!parsed) {
    return '-';
  }

  return new Intl.DateTimeFormat(locale, {
    day: 'numeric',
    month: 'short',
    year: 'numeric'
  }).format(parsed);
};

export const formatRecordTime = (value, locale = 'tr-TR') => {
  const parsed = parseRecordDate(value);

  if (!parsed) {
    return '--:--';
  }

  return new Intl.DateTimeFormat(locale, {
    hour: '2-digit',
    minute: '2-digit'
  }).format(parsed);
};
